import { fetchSettings } from '@app/services/legendService'
import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { isAuthenticatedAtom } from '@app/state/authAtom'

/**
 * Fetches client settings and caches them with React Query.
 * Uses clientName in the key so we refetch when it changes.
 */
export function useFetchSettings(clientName: string) {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)

  return useQuery<unknown>({
    queryKey: ['settings', clientName],
    queryFn: fetchSettings,
    enabled: isAuthenticated && Boolean(clientName),
  })
}
